import SliceNames from '@/state/enum';
import { IStore } from '@/state/slices/typings';

const getWindowSlice = (state: IStore) => state[SliceNames.WINDOW];

export default getWindowSlice;
